import { render, staticRenderFns } from "./IconTrendingUp.vue?vue&type=template&id=69cdce00"
import script from "./IconTrendingUp.vue?vue&type=script&lang=js"
export * from "./IconTrendingUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports